import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.css']
})
export class CommentsComponent implements OnInit {


  @Input() formname: string = "";
  @Input() formtype: string = "";

  @Input() formid: string = "";

  @Output() approvecloseChanged = new EventEmitter();

  approveColl: any = [];

  approveform = new FormGroup({
    reasondesc: new FormControl('', Validators.required),
  });


  submitted: boolean;
  successfully: boolean;

  userlogoimgpath: string = "";

  constructor(private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, private datePipe: DatePipe) {
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      this.userlogoimgpath = this.loginService.userBO.logoimgpath;
    });
  }

  ngOnInit() {
    this.approveform.reset();
    this.fnInitializeFormGroup();
    this.fnGetApproveForms();

    console.log(this.loginService.userBO);

    this.userlogoimgpath = this.loginService.userBO.logoimgpath;




  }



  fnInitializeFormGroup() {
    this.approveform.setValue({
      reasondesc: '',
    })


    this.submitted = false;
    this.successfully = false;
  }

  //Insert
  fnInsertApprove() {

    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.approveform.valid) {
        var data = {
          formname: this.formname,
          trxid: this.formid,
          approvalstatus: this.formtype,
          reasondesc: this.approveform.get('reasondesc').value,
          approvedby: this.loginService.fnGetModUserId()
        }


        this.appService.fnInsertApprovals(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              if (res.json().result != "") {
                this.approvecloseChanged.emit('DONE');
              }
            }
            else {
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnGetApproveForms() {
    var data = {
      formname: this.formname,
      trxid: this.formid,
    }


    this.appService.getApprovalsForms(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          this.approveColl = res.json().result;
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
